import { render, staticRenderFns } from "./member-detail.vue?vue&type=template&id=326a331c&scoped=true&"
import script from "./member-detail.vue?vue&type=script&lang=js&"
export * from "./member-detail.vue?vue&type=script&lang=js&"
import style0 from "./member-detail.vue?vue&type=style&index=0&id=326a331c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326a331c",
  null
  
)

export default component.exports